import { useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import {
	hasSizesState,
	hasProductVersionsState,
	hasModifierGroupsState,
	hasModifierScalesState
	// hasNutritionState
} from '../../atoms';
import { ModifierGroups } from '../ModifierGroups';
import { ModifierScales } from '../ModifierScales';
import { Size } from '../Size';
import { OtherVersions } from '../OtherVersions';
import { Divider } from '../../../components/Divider';

export type ProductBodyProps = {
	autoModify?: boolean;
};

export const ProductBody: React.FC<ProductBodyProps> = ({ autoModify }) => {
	const hasSize = useRecoilValue(hasSizesState);
	const hasProductVersions = useRecoilValue(hasProductVersionsState);
	const hasModifierGroups = useRecoilValue(hasModifierGroupsState);
	const hasModifierScales = useRecoilValue(hasModifierScalesState);

	const hasOptions = useMemo(
		() =>
			hasSize ||
			hasProductVersions ||
			(autoModify && (hasModifierGroups || hasModifierScales)),
		[
			autoModify,
			hasModifierGroups,
			hasModifierScales,
			hasProductVersions,
			hasSize
		]
	);

	return (
		<div style={{ marginBottom: '90px' }}>
			{hasOptions && (
				<>
					<h1 className="text-primary font-weight-bold mb-3">
						Build Yours
					</h1>

					<Divider my={0} />
				</>
			)}

			{hasSize && <Size />}
			{hasProductVersions && <OtherVersions />}
			{autoModify && (
				<>
					{hasModifierScales && <ModifierScales />}
					{hasModifierGroups && <ModifierGroups />}
				</>
			)}

			<div className="py-3 d-lg-none">
				<a
					className="font-weight-bold d-block text-primary"
					target="_blank"
					rel="noreferrer"
					href="https://biggby.com/nutrition"
				>
					Nutrition Information
				</a>

				<a
					className="font-weight-bold d-block"
					target="_blank"
					rel="noreferrer"
					href="https://biggby.com/nutrition"
				>
					Allergen Information
				</a>
			</div>
		</div>
	);
};

export default ProductBody;
